import React, { useState } from 'react'
import styled, { withTheme } from 'styled-components'
import { get } from 'lodash'
import Iconfont from './Iconfont'
import { setLanguageStore, getLanguageStore } from './storage'

const languages = [
  { value: 'cn', name: '中文' },
  { value: 'en', name: ' EN ' },
]
const languagesMap = languages.reduce((acc, cur) => {
  acc[cur.value] = cur
  return acc
}, {})

const Language = styled.li`
  font-size: ${({ theme: { size } }) => (size === 'large' ? '14px' : '12px')};
  .tnt-icon {
    font-size: ${({ theme: { size } }) => (size === 'large' ? '24px' : '20px')};
    margin-right: 4px;
  }
  span {
    position: relative;
    font-size: ${({ theme: { size } }) => (size === 'large' ? '14px' : '12px')};
    top: ${({ theme: { size } }) => (size === 'large' ? '-3px' : '-2px')};
    font-family: auto;
    .tnt-themeS1 & {
      /* color: rgba(255,255,255,.85); */
    }
  }
  .isInIframe & {
    display: none;
  }
`

export default withTheme((props) => {
  const { onChange } = props
  const getLanguage = () => {
    let lang = getLanguageStore() || props.language

    if (!languagesMap[lang]) {
      lang = get(languages, '0.value')
    }

    return lang
  }
  const [language = 'cn', setLanguage] = useState(getLanguage())
  const switchLanguage = () => {
    const lang = language === 'cn' ? 'en' : 'cn'

    setLanguage(lang)
    setLanguageStore(lang)
    onChange && onChange(lang)
  }

  return (
    <Language onClick={switchLanguage}>
      <Iconfont type={`flag-${language}`} />
      <span>{get(languagesMap[language], 'name')}</span>
    </Language>
  )
})
